// Copyright (c) 2016 Deere & Company

import KeyValuePairCollection from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';
import actions from '../../action-list';
import {getDefaultState as getClaimDefaultState} from '../state';

const updateLugHeightUnitCollection = (state, action) =>
    KeyValuePairCollection.update(state, {
        $set: action.data
    });

export default (state = getClaimDefaultState().lugHeightUnitCollection, action) => {

    const actionTypes = {
        [actions.UPDATE_CLAIM_TRACK_LUGHEIGHT_UNIT_COLLECTION]: updateLugHeightUnitCollection
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/track/reducers/lug-height-units.js